import React from "react";
import { StyledLabel } from "./AccountAdmin.styled";

export const renderField = (label: string, value: string) => (
    <div>
        <StyledLabel>{label}: </StyledLabel>
        {value}
    </div>
);
